module.exports = __webpack_public_path__ + "883c4fe466990cb1fdfc0550e1edd38f.pdf";